// removed by extract-text-webpack-plugin
module.exports = {"Rating":"___Rating__Rating___rscU7"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Rating/Rating.less
// module id = 1021
// module chunks = 0